export const getEnvironment = () =>  import.meta.env.VITE_ENVIRONMENT || 'development';
